import e from"./RefinementList.vue_vue&type=script&lang.js";import{render as t}from"./RefinementList.vue_vue&type=template&id=28927239&lang.js";e.render=t,e.__file="src/components/RefinementList.vue";export default e;
//# sourceMappingURL=RefinementList.vue.js.map
